<template>
    <div class="sellpanel">
        <span
            v-for="item in innerData"
            :key="item.sellPointContentId"
            v-dragging="needDrag ? {item: item, list: innerData, group: 'item'} : {}"
            class="tag-warpper"
        >
            <el-tooltip
                :content="item.sellPointTypeName"
                :open-delay="300"
                placement="top"
            >
                <el-tag
                    size="medium"
                    :closable="editable"
                    type="primary"
                    @close="removeTag(item.sellPointContentId)"
                >{{ `${item.sellPointContentName}` }}</el-tag>
            </el-tooltip>
        </span>
        <span v-if="!innerData.length && !editable">无</span>
        <template v-if="editable">
            <el-button
                v-if="!sellSelect"
                class="add-btn"
                size="mini"
                :disabled="disabled"
                icon="el-icon-plus"
                @click="show"
            />
            <el-button
                v-else
                class="sell-select-button"
                size="mini"
            >
                <div>
                    <el-select
                        ref="selectNode"
                        v-model="selectedSell"
                        filterable
                        remote
                        :remote-method="fetchSellPoints"
                        :loading="loading"
                        placeholder="搜索卖点内容"
                        size="small"
                        @change="addSellPoint"
                        @blur="hide()"
                    >
                        <el-option
                            v-for="item in searchResult"
                            :key="item.sellPointContentId"
                            :label="item.sellPointContentName"
                            :value="item"
                            :disabled="valueList.indexOf('' + item.sellPointContentId) !== -1"
                        />
                    </el-select>
                </div>
            </el-button>

            <mc-button
                v-if="isShowAiSellingBtn && !isShowAiSellingPoint"
                size="small"
                type="primary"
                @click="addAISellPoint"
            >
                AI生成卖点
            </mc-button>
        </template>
        <div
            v-if="isShowAiSellingPoint && aiSellingPoints.length"
            class="ai-sellpanel"
        >
            <div class="title">
                AI推荐卖点
            </div>
            <div class="content">
                <mc-button
                    v-for="item in aiSellingPoints"
                    :key="item.point"
                    size="small"
                    style="margin-left: 5px"
                    @click="addAiSellPoint(item)"
                >
                    {{ item.point }}
                </mc-button>
            </div>
            <mc-button
                size="small"
                type="primary"
                @click="queryAiData"
            >
                重新生成
            </mc-button>
        </div>

        <AiSellPointDlg
            ref="aiSellPointDlg"
            :is-create-new-refer="isCreateNewRefer"
            @add="addSelllPoint"
        />
    </div>
</template>

<script>
import { debounce, hPost } from '@mcfe/tools';
import AiSellPointDlg from './AiSellPointDlg';
import { aiSellingData, queryAiData, isNullSellPoint } from '../composables/useSellingPointsBuyerAi';

const ARTIFICIAL = 107;


export default {
    name: 'SellPanel',
    components: {
        AiSellPointDlg,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        editable: {
            type: Boolean,
            default: false,
        },
        isShowAdd: {
            type: Boolean,
            default: false,
        },
        needDrag: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        skuBaseId: {
            type: [String, Number],
            required: true,
        },
        isShowAiSellingBtn: {
            type: Boolean,
            default: false,
        },
        isCreateNewRefer: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            aiSellingData,
            queryAiData,
            innerData: this.value || [],
            sellSelect: false, // +号的开关
            selectedSell: null,
            searchResult: [],
            keyword: '', // 搜索关键词
            loading: false,
        };
    },
    computed: {
        valueList() {
            return this.innerData.map(
                (v) => v.sellPointContentId,
            );
        },
        handleInnerData() {
            return this.innerData.map((item, idx) => ({
                ...item,
                sequence: idx,
                skuBaseId: this.skuBaseId,
            }));
        },
        aiSellingPoints() {
            return aiSellingData.value?.sellingPoints || [];
        },
        isShowAiSellingPoint() {
            return this.isCreateNewRefer && isNullSellPoint.value;
        },
    },
    watch: {
        value(newVal) {
            this.innerData = newVal;
        },
    },
    created() {
    },
    methods: {
        // 搜索
        show() {
            this.selectedSell = null;
            this.sellSelect = true;
            this.$nextTick(() => {
                this.$refs.selectNode.focus();
            });
        },
        hide(immediately = false) {
            setTimeout(() => {
                this.sellSelect = false;
                // 不清空好像效果好一点
                this.searchResult = [];
            }, immediately ? 0 : 500);
        },
        addSellPoint(tag) {
            if (this.valueList.indexOf(tag.sellPointContentId) !== -1) {
                this.hide(true);
                return;
            }
            this.innerData.push(tag);
            this.hide(true);
            this.$emit('input', this.handleInnerData);
        },
        removeTag(id) {
            const sellIndex = this.valueList.indexOf(id);
            if (sellIndex === -1) {
                return;
            }
            const list = [...this.innerData];
            list.splice(sellIndex, 1);
            this.innerData = list;
            this.$emit('input', this.handleInnerData);
        },
        fetchSellPoints(keyword) {
            this.keyword = keyword;
            if (!keyword) {
                this.searchResult = [];
                return;
            }
            this.loading = true;

            this.$post(
                `${window.location.origin}/api/vss/shepherd/product/searchSellPointAllList`,
                {
                    sellPointContentName: keyword,
                    sellPointTypeId: -1,
                    paging: {
                        limit: 10,
                        offset: 0,
                    },
                },
            ).then((res) => {
                if (keyword !== this.keyword) {
                    return;
                }
                const dataList = res.resultList.filter((v) => (
                    v
                        && v.sellPointContentId
                        && this.valueList.indexOf(`${v.sellPointContentId}`) === -1
                ));
                this.loading = false;
                this.searchResult = dataList;
                if (!res.resultList.length && keyword) this.addSellPanel(keyword);
            });
        },

        addAISellPoint() {
            this.$refs.aiSellPointDlg.popup(this.skuBaseId);
        },

        addSelllPoint(aiSellPoints) {
            for (let i = 0; i < aiSellPoints.length; i++) {
                const stackSellPoint = aiSellPoints[i];
                const sellPointSelected = this.innerData.find((item) => item?.sellPointContentName === stackSellPoint?.sellPointContentName);
                if (!sellPointSelected && stackSellPoint) {
                    this.innerData.push(stackSellPoint);
                }
            }
            this.$emit('input', this.handleInnerData);
        },

        async addAiSellPoint(item) {
            const sellPointItem = await this.$refs.aiSellPointDlg.querySellPointExist(item.point);
            if (!sellPointItem) {
                const res = await this.$refs.aiSellPointDlg.addSellPoint(item.point);
                this.innerData.push({
                    sellPointContentId: res.sellPointContentId,
                    sellPointContentName: res.sellPointContentName,
                    sellPointTypeName: res.sellPointTypeName,
                    sellPointTypeId: res.sellPointTypeId,
                });
            } else if (!this.innerData.find((sellItem) => sellItem.sellPointContentId === sellPointItem.sellPointContentId)) {
                this.innerData.push(sellPointItem);
            } else {
                this.$mc.message.warning('请勿重复添加');
            }
        },

        addSellPanel: debounce(function (keyword) {
            this.$mc.confirm({
                title: '是否新增',
                message: `当前卖点库无【${keyword}】卖点，是否新增`,
                width: '430px',
                showCancelButton: true,
                onOk: async () => {
                    const params = {
                        sellPointContentName: keyword,
                        sellPointContentId: -1,
                        sellPointTypeId: ARTIFICIAL,
                    };
                    const res = await hPost('/api/vss/shepherd/productapi/sellpoint/vssAddSellPointContent', params);
                    this.$mc.message.success('添加成功');
                    this.innerData.push({
                        sellPointContentId: res.sellPointContentId,
                        sellPointContentName: res.sellPointContentName,
                        sellPointTypeName: res.sellPointTypeName,
                        sellPointTypeId: res.sellPointTypeId,
                    });
                    this.$emit('input', this.handleInnerData);
                },
            }).catch(() => {});
        }, 2000),
    },
};
</script>
<style scoped lang="scss">
.sellpanel {
    min-height: 40px;
    .tag-warpper {
        cursor: pointer;
    }
    .add-btn {
        min-width: 30px;
    }
    .sell-select-button {
        transition: none;
        padding: 0;
        border: none;
    }
    .el-tag {
        margin: 3px;
    }
}
.ai-sellpanel {
    margin-top: 5px;
    width: 500px;
    padding: 5px 10px;
    border: 1px solid #f3f5f7;
    text-align: right;
    .content {
        text-align: left;
    }
    .title {
        font-weight: bold;
        margin-left: 5px;
        text-align: left;
    }
}
</style>
